import {
    DefaultHitsPerPage,
    HitsPerPageConfiguration
} from "@/components/Search/SearchResults/StateComponents/HitsPerPage/hitsPerPage.config";
import { useThunkDispatch } from "@/redux/dispatcher";
import { configureSearchComponent } from "@/redux/modules/value/search/search.actions";
import { useSearchComponentStateSelector } from "@/redux/modules/value/search/search.selectors";
import { getInvalidationsForComponent } from "@/utils/search/invalidation.utils";
import { SearchComponentOfType } from "@/utils/search/types/searchComponent";

import { HitsPerPageComponent } from "./hitsPerPage.component";

type HitsPerPageProps = {
    component: SearchComponentOfType<"HITS_PER_PAGE">;
    className?: string;
};

export type HitsPerPageConfig = {
    label: string;
    value: number;
    isRefined: boolean;
};

const HitsPerPage = ({ component, className }: HitsPerPageProps) => {
    const dispatch = useThunkDispatch();
    const hitsPerPageComponentState =
        useSearchComponentStateSelector(component);

    const refinedHitsPerPage =
        hitsPerPageComponentState?.hitsPerPage ?? DefaultHitsPerPage;

    const items: Array<HitsPerPageConfig> = HitsPerPageConfiguration.map(
        (hitsPerPage) => ({
            label: hitsPerPage.label,
            value: hitsPerPage.value,
            isRefined: hitsPerPage.value === refinedHitsPerPage
        })
    );
    const refinedItem = items.find((hitsPerPage) => hitsPerPage.isRefined);

    const handleOnRefine = (value: number) => {
        dispatch(
            configureSearchComponent(
                {
                    component: component,
                    hitsPerPage: value
                },
                getInvalidationsForComponent(component)
            )
        );
    };

    return (
        <HitsPerPageComponent
            key={refinedItem?.value}
            items={items}
            refinedItem={refinedItem}
            refine={handleOnRefine}
            className={className}
        />
    );
};

export { HitsPerPage };
